// 통지 팝업
<template>
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001553') + ' / ' + getMessage_('QWCC001502')" :show="show" :closeModal="close">
		<sf-data-table
			ref="popupTable"
			:columns="columns"
			:rows="infmResultList"
			height="80vh"
			fit="fit"
			:stripe="false"
			:excel="isButton_(scrId, 'EX')"
		>
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'mark'">
					<template v-if="(slotProps.row.calStCd === 'RGST' || slotProps.row.calStCd === 'INFM') && slotProps.row.runStCd === 'NORM'">
						<!-- 등록, 통지 상태일 때 -->
						<i class="icon-sf-circle-bottom successed"></i>
					</template>
					<template v-else>
						<i class="icon-sf-circle-close warned"></i>
					</template>
				</template>
			</template>
			<template v-slot:actionsLeft>
				<!-- 통지 -->
				<sf-button v-if="isButton_(scrId, 'CU') && isMmcAdmin" line icon="notice" :onClick="infmAction">
					{{ getMessage_('QWCC001553') }}
				</sf-button>
				<!-- 이메일 전송 -->
				<sf-button line icon="mail" :onClick="sendAction" v-if="isButton_(scrId, 'SD') && isMmcAdmin">
					{{ getButtonMsg_(scrId, 'SD') }}
				</sf-button>
			</template>
		</sf-data-table>
		<popup-eml ref="popupEml" :scrId="scrId"></popup-eml>
		<!-- 담당자 정보가 없거나, 가동상태가 정상이 아닐 경우 메일 선택이 제한될 수 있습니다. -->
		<div class="mt-2">*** {{ getMessage_('QWCC001585') }} ***</div>
	</sf-modal-layout>
</template>

<script>
import _ from 'lodash';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesInfm/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import PopupEml from './PopupEml/PopupEml.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false
		};
	},
	components: {
		PopupEml
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open() {
			this.show = true;
		},
		close(success) {
			this.setState_({ key: 'infmResultList', value: [] });
			this.show = false;
			!!success && this.refresh();
		},
		refresh() {
			this.$emit('Refresh');
		},
		openPopupEml(row) {
			this.$refs.popupEml.open(row.mesEqipNo);
		},
		infmAction() {
			try {
				const filteredList = _.filter(this.infmResultList, row => row.infm == true);
				if (!filteredList.length) {
					throw new Error(this.getMessage_('QWCC001556'));
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001583'), //통지 처리 하시겠습니까?
					buttons: [{ title: 'Ok', clickFn: () => this.sendInfm(filteredList) }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async sendInfm(rows) {
			this.$sf_toggleLoading(true);
			try {
				const header = await this.alreadyInfm_(this.sendInfo(rows));
				if (header?.code == 0) {
					this.$sf_showMessage({
						icon: 'ok',
						message: this.getMessage_(header.messageCd),
						closeFn: () => this.close('success')
					});
				} else {
					throw new Error(this.getMessage_(header?.messageCd));
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		// 이메일 전송 의향 확인
		sendAction() {
			try {
				if (!this.user.email) {
					throw new Error(this.getMessage_('QWCC001578')); //사용자 정보에서 사용자의 이메일을 확인해주시길 바랍니다.
				}
				const filteredRows = _.filter(this.infmResultList, el => {
					return el.user1Yn === true || el.user2Yn === true;
				});
				if (!filteredRows.length) {
					throw new Error(this.getMessage_('QWCC001556')); //선택한 행이 없습니다.
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001513'), //메일을 전송하시겠습니까?
					buttons: [{ title: 'Ok', clickFn: () => this.sendEmail(filteredRows) }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		// 이메일 전송단
		async sendEmail(rows) {
			this.$sf_toggleLoading(true);
			try {
				const header = await this.sendEmail_(this.sendInfo(rows));
				if (header?.code == 0) {
					// 정상적으로 메일이 보내졌습니다. 최대 20분 안으로 메일이 전송됩니다.
					this.$sf_showMessage({
						title: this.getMessage_('QWCC001587'),
						icon: 'ok',
						message: this.getMessage_('QWCC001493'),
						closeFn: () => this.close('success')
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		// 이메일 정보 취합
		sendInfo(rows) {
			return rows.map(el => {
				let rcptNm = '';
				let rcptAdr = '';
				if ((el.user1Yn && el.infm) && el.user1Nm && el.user1Adr) {
					rcptNm += el.user1Nm;
					rcptAdr += el.user1Adr;
					if ((el.user2Yn && el.infm) && el.user2Nm && el.user2Adr) {
						rcptNm += `;${el.user2Nm}`;
						rcptAdr += `;${el.user2Adr}`;
					}
				} else if ((el.user2Yn && el.infm) && el.user2Nm && el.user2Adr) {
					rcptNm += el.user2Nm;
					rcptAdr += el.user2Adr;
				}
				return {
					mesEqipNo: el.mesEqipNo,
					dsprNm: this.user.userName,
					dsprAdr: this.user.email,
					rcptNm,
					rcptAdr
				};
			});
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: ' ',
					prop: 'mark',
					minWidth: '35px',
					custom: true,
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001553'), //통지 체크박스
					prop: 'infm',
					minWidth: '55px',
					sortable: false,
					form: {
						type: 'checkBox',
						isDisabled: ({ row }) => {
							const emlStandard = (row.calStCd == 'RGST' || row.calStCd == 'INFM') && row.runStCd === 'NORM';
							return !emlStandard ? true : false;
						}
					}
				},

				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC000982'), //정담당자
					prop: 'user1Id',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC000982'), //정담당자
					prop: 'user1Nm',
					sortable: false,
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001567'), //메일 전송
					prop: 'user1Yn',
					minWidth: '80px',
					sortable: false,
					form: {
						type: 'checkBox',
						isDisabled: ({ row }) => {
							const emlStandard = (row.calStCd === 'RGST' || row.calStCd === 'INFM') && row.runStCd === 'NORM';
							const userStandard = !row.user1Id || !row.user1Nm || !row.user1Adr;
							return !emlStandard || userStandard ? true : false;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001847'), //부담당자
					prop: 'user2Id',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001847'), //부담당자
					prop: 'user2Nm',
					sortable: false,
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001567'), //메일 전송
					prop: 'user2Yn',
					minWidth: '80px',
					sortable: false,
					form: {
						type: 'checkBox',
						isDisabled: ({ row }) => {
							const emlStandard = (row.calStCd === 'RGST' || row.calStCd === 'INFM') && row.runStCd === 'NORM';
							const userStandard = !row.user2Id || !row.user2Nm || !row.user2Adr;
							return !emlStandard || userStandard ? true : false;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001323'), //교정주기
					prop: 'calCyclCd',
					minWidth: '99px',
					form: {
						type: 'select',
						options: this.calCyclCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001324'), //차기교정일
					prop: 'nextCalDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001552'), //메일발송일시
					prop: 'emlSndDd',
					minWidth: '100px',
					highlight: true,
					clickEvent: this.openPopupEml
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '80px',

					form: {
						type: 'select',
						options: this.runStCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001316'), //교정상태
					prop: 'calStCd',
					minWidth: '80px',

					form: {
						type: 'select',
						options: this.calStCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				}
			];
		}
	}
};
</script>

<style lang="scss">
.el-checkbox__input .is-disabled {
	& > .el-table .el-checkbox__input .el-checkbox__inner {
		cursor: not-allowed !important;
	}
}
.el-table .el-checkbox__input .el-checkbox__inner {
	cursor: pointer;
}
</style>
